import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SyncApiService } from './sync-api.service';
import { filter, map } from 'rxjs/operators';
import { Group, TypeAHeadContactsResponse, TypeAHeadResponse } from 'src/app/shared/types/typeahead';
import { SearchTermType } from 'src/app/shared/enums/typeahead';

@Injectable({ providedIn: 'root' })
export class TypeaheadSearchApiService {
  constructor(private api: SyncApiService) {}

  suggestRecordings(query: string, type: SearchTermType): Observable<Group[] | null> {
    const url = 'typeahead/search/recordings';
    return this.getSearchTypeaheadSuggestions(url, query, type);
  }

  suggestWorks(query: string, type: SearchTermType): Observable<Group[] | null> {
    const url = 'typeahead/search/works';
    return this.getSearchTypeaheadSuggestions(url, query, type);
  }

  contacts(query: string, limit: number = 10): Observable<TypeAHeadContactsResponse[]> {
    return this.api.get<TypeAHeadContactsResponse[]>('typeahead/search/contacts', {
      query,
      limit
    });
  }

  private getSearchTypeaheadSuggestions(
    requestUrl: string,
    query: string,
    type: SearchTermType,
    limit: number = 5
  ): Observable<Group[] | null> {
    if (!query) {
      return of(null);
    }
    return this.api
      .get<TypeAHeadResponse>(requestUrl, {
        query,
        type,
        limit
      })
      .pipe(
        filter(v => v && Boolean(v.groups)),
        map(v => v.groups)
      );
  }
}
